/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': '선택 항목 지우기',
  'paginated-picker.async-select.menu-list.error-message.error-message': '데이터를 검색할 수 없음',
  'paginated-picker.async-select.menu-list.error-message.retry-message': '클릭하여 다시 시도',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': '로드 중...',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': '더 보기',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': '일치하는 항목 없음',
  'paginated-picker.async-select.select.option.error-message': '데이터를 검색할 수 없음',
  'paginated-picker.async-select.select.option.retry-message': '클릭하여 다시 시도',
  'paginated-picker.async-select.select.search-placeholder': '검색',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': '전체 목록 표시'
};